<template>
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_assistenza']"/>

    <b-row>
      <b-col>
        <div id="iframe-container">
          <b-embed type="iframe" :src="faq_url"></b-embed>
        </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'

export default {
  name: 'FaqView',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "FaqView", link : 'site-faq' } ],
      // Faq url
      faq_page_path : "/php/public/frequently_asked_questions.php"
    }
  },
  computed : {
    /**
     * Calcola la stringa per le faq a seconda dell'ambiente in cui ci troviamo.
     * Le faq sono ospitate nella parte backoffice
     */
    faq_url : function () {
      // Verifichiamo le varie alternative basandoci sull'url
      if ( window.document.location.origin.includes('10.20.6.16') ) {
        // Siamo in sviluppo
        return "http://welfare.namirial.it" + this.faq_page_path;
      } else if ( window.document.location.origin.includes('temporaneo') ||
                  window.document.location.origin.includes('demo') ) {
        // Siamo in backoffice demo
        return "https://backoffice-demo.welfarebit.it" + this.faq_page_path;
      } else if ( window.document.location.origin.includes('bccfano') ) {
        // Siamo su backoffice bccfano
        return "https://backoffice-bccfano.welfarebit.it" + this.faq_page_path;
      } else {
        // Siamo su backoffice userportal
        return "https://backoffice.welfarebit.it" + this.faq_page_path;
      }
    }
  },
  components : {
    PageTagline,
    TutorialContestuale
  }
}
</script>


<style scoped>
/* Sistemiamo l'altezza dell'iframe a seconda del dispositivo
   settando l'altezza del div container in percentuale al viewport */
#iframe-container :deep( .embed-responsive ) {
  height: 100vh;
}
@media (max-width: 768px) {
  #iframe-container :deep( .embed-responsive ) {
    height: 70vh;
  }
}
@media (max-width: 576px) {
  #iframe-container :deep( .embed-responsive ) {
    height: 60vh;
  }
}
</style>